import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { IconButton } from '@udemy/react-core-components';
import styles from "./mweb-overlay-search-form-autocomplete.module.css";
export const MWebOverlaySearchStyles = {
  autocomplete: styles['overlay-autocomplete'],
  form: styles['overlay-form'],
  input: styles['overlay-input'],
  submitButton: styles['overlay-submit-button'],
  suggestions: styles['overlay-suggestions']
};
/**
 * Reusable top navigation bar for mobile search overlays.
 * Designed to wrap a SearchFormAutocomplete in a pill-shaped container with a back arrow and clear button.
 */
export function MWebOverlaySearchFormAutocomplete({
  onClose,
  onClearInput,
  showClearButton = true,
  children
}) {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement("div", {
    className: styles['top-search-nav']
  }, /*#__PURE__*/React.createElement(IconButton, {
    udStyle: "ghost",
    onClick: onClose,
    className: styles['back-button'],
    "data-testid": "search-overlay-back"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "arrow-left",
    color: "neutral",
    label: gettext('Go back')
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['search-pill-container']
  }, children, showClearButton && /*#__PURE__*/React.createElement(IconButton, {
    udStyle: "ghost",
    onClick: onClearInput,
    className: styles['close-button'],
    "data-testid": "search-overlay-clear"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "close",
    color: "neutral",
    label: gettext('Clear search text')
  }))));
}
//# sourceMappingURL=mweb-overlay-search-form-autocomplete.react-component.js.map